import { useState, useEffect } from "react";
import { getStores } from "../api/client";

const API = (path, opts = {}) => {
  const token = localStorage.getItem("farmavida_token");
  return fetch("/api" + path, {
    ...opts,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, ...(opts.headers || {}) }
  }).then(r => r.json());
};

const BUCKETS = [
  { key: "menos_3", label: "< 3 meses", color: "#ef4444", bg: "#fef2f2", border: "#fecaca" },
  { key: "3_a_6",   label: "3 – 6 meses", color: "#f59e0b", bg: "#fffbeb", border: "#fde68a" },
  { key: "6_a_9",   label: "6 – 9 meses", color: "#6366f1", bg: "#eef2ff", border: "#c7d2fe" },
  { key: "mas_9",   label: "+ 9 meses",  color: "#10b981", bg: "#ecfdf5", border: "#a7f3d0" },
];

const emptyForm = { first_name: "", last_name: "", cedula: "", store_id: "", weekly_salary: "", monthly_salary: "", cesta_ticket: "", hire_date: "" };

export default function Payroll() {
  const [stability, setStability] = useState(null);
  const [stores, setStores] = useState([]);
  const [filterStore, setFilterStore] = useState("");
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [expandedBucket, setExpandedBucket] = useState(null);

  const fetchData = async (storeId = "") => {
    setLoading(true);
    try {
      const url = "/employees/stability" + (storeId ? `?store_id=${storeId}` : "");
      const data = await API(url);
      setStability(data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => {
    getStores().then(s => setStores(s || [])).catch(() => {});
    fetchData();
  }, []);

  const handleStoreFilter = (sid) => {
    setFilterStore(sid);
    fetchData(sid);
  };

  const handleEdit = (emp) => {
    setForm({
      first_name: emp.first_name, last_name: emp.last_name, cedula: emp.cedula,
      store_id: emp.store_id, weekly_salary: emp.weekly_salary, monthly_salary: emp.monthly_salary,
      cesta_ticket: emp.cesta_ticket ?? "", hire_date: emp.hire_date
    });
    setEditingId(emp.id);
    setShowForm(true);
    setError("");
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar este empleado?")) return;
    await API(`/employees/${id}`, { method: "DELETE" });
    fetchData(filterStore);
  };

  const handleSubmit = async () => {
    if (!form.first_name || !form.last_name || !form.cedula || !form.store_id || !form.hire_date) {
      setError("Completa todos los campos obligatorios"); return;
    }
    setSaving(true); setError("");
    try {
      if (editingId) {
        await API(`/employees/${editingId}`, { method: "PUT", body: JSON.stringify(form) });
      } else {
        await API("/employees", { method: "POST", body: JSON.stringify(form) });
      }
      setShowForm(false); setForm(emptyForm); setEditingId(null);
      fetchData(filterStore);
    } catch (e) {
      setError("Error al guardar");
    }
    setSaving(false);
  };

  const storeName = (id) => stores.find(s => s.id === id)?.name || id;

  return (
    <div style={{ padding: "24px", maxWidth: 1200, margin: "0 auto" }}>

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: "#1e293b", margin: 0 }}>👥 Estabilidad de Nómina</h1>
          <p style={{ color: "#64748b", fontSize: 14, margin: "4px 0 0" }}>Distribución de empleados por antigüedad</p>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
          <select value={filterStore} onChange={e => handleStoreFilter(e.target.value)}
            style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13, color: "#1e293b", background: "white" }}>
            <option value="">Todas las sedes</option>
            {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <button onClick={() => { setShowForm(true); setForm(emptyForm); setEditingId(null); setError(""); }}
            style={{ background: "#6366f1", color: "white", border: "none", borderRadius: 8, padding: "8px 18px", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
            + Agregar Empleado
          </button>
        </div>
      </div>

      {/* Totales */}
      {stability && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 14, marginBottom: 24 }}>
          {[
            { label: "Total Empleados", value: stability.total, icon: "👥" },
            { label: "Nómina Semanal", value: `$${stability.total_weekly_all?.toLocaleString("en-US", { minimumFractionDigits: 2 })}`, icon: "💵" },
            { label: "Nómina Mensual", value: `$${stability.total_monthly_all?.toLocaleString("en-US", { minimumFractionDigits: 2 })}`, icon: "📅" },
            { label: "Cesta Ticket Total", value: `$${(stability.total_cesta_all || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}`, icon: "🧺" },
          ].map((item, i) => (
            <div key={i} style={{ background: "white", borderRadius: 12, padding: "18px 20px", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 24 }}>{item.icon}</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: "#1e293b", marginTop: 6 }}>{item.value}</div>
              <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 2 }}>{item.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Columnas de antigüedad */}
      {loading ? (
        <div style={{ textAlign: "center", padding: 60, color: "#94a3b8" }}>Cargando...</div>
      ) : stability && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 16, marginBottom: 24 }}>
          {BUCKETS.map(bucket => {
            const data = stability[bucket.key] || {};
            const isExpanded = expandedBucket === bucket.key;
            return (
              <div key={bucket.key} style={{ background: "white", borderRadius: 14, border: `1px solid ${bucket.border}`, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                {/* Cabecera de columna */}
                <div style={{ background: bucket.bg, padding: "16px 18px", borderBottom: `1px solid ${bucket.border}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontWeight: 700, fontSize: 15, color: bucket.color }}>{bucket.label}</span>
                    <span style={{ background: bucket.color, color: "white", borderRadius: 20, padding: "2px 12px", fontSize: 13, fontWeight: 700 }}>
                      {data.count || 0}
                    </span>
                  </div>
                  {/* Barra de porcentaje */}
                  <div style={{ marginTop: 10 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#64748b", marginBottom: 4 }}>
                      <span>Participación</span>
                      <span style={{ fontWeight: 700, color: bucket.color }}>{data.percentage || 0}%</span>
                    </div>
                    <div style={{ background: "#e2e8f0", borderRadius: 99, height: 8 }}>
                      <div style={{ background: bucket.color, borderRadius: 99, height: 8, width: `${data.percentage || 0}%`, transition: "width 0.5s ease" }} />
                    </div>
                  </div>
                  <div style={{ marginTop: 10, display: "flex", gap: 16, fontSize: 12, color: "#64748b", flexWrap: "wrap" }}>
                    <span>Sem: <strong style={{ color: "#1e293b" }}>${(data.total_weekly || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}</strong></span>
                    <span>Mes: <strong style={{ color: "#1e293b" }}>${(data.total_monthly || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}</strong></span>
                    <span>CT: <strong style={{ color: "#1e293b" }}>${(data.total_cesta || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}</strong></span>
                  </div>
                </div>

                {/* Lista de empleados */}
                <div>
                  <button onClick={() => setExpandedBucket(isExpanded ? null : bucket.key)}
                    style={{ width: "100%", background: "none", border: "none", padding: "10px 18px", cursor: "pointer", fontSize: 12, color: "#6366f1", fontWeight: 600, textAlign: "left" }}>
                    {isExpanded ? "▲ Ocultar empleados" : `▼ Ver ${data.count || 0} empleados`}
                  </button>
                  {isExpanded && (data.employees || []).map(emp => (
                    <div key={emp.id} style={{ padding: "10px 18px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 13, color: "#1e293b" }}>{emp.first_name} {emp.last_name}</div>
                        <div style={{ fontSize: 11, color: "#94a3b8" }}>CI: {emp.cedula} • {storeName(emp.store_id)}</div>
                        <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>
                          Ingreso: {emp.hire_date} • Sem: ${emp.weekly_salary} • Mes: ${emp.monthly_salary}{emp.cesta_ticket > 0 ? ` • CT: $${emp.cesta_ticket}` : ""}
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button onClick={() => handleEdit(emp)}
                          style={{ background: "#eef2ff", color: "#6366f1", border: "none", borderRadius: 6, padding: "4px 10px", fontSize: 12, cursor: "pointer", fontWeight: 600 }}>✏️</button>
                        <button onClick={() => handleDelete(emp.id)}
                          style={{ background: "#fef2f2", color: "#ef4444", border: "none", borderRadius: 6, padding: "4px 10px", fontSize: 12, cursor: "pointer", fontWeight: 600 }}>🗑️</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal formulario */}
      {showForm && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "white", borderRadius: 16, padding: 28, width: "100%", maxWidth: 480, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
            <h2 style={{ margin: "0 0 20px", fontSize: 18, fontWeight: 800, color: "#1e293b" }}>
              {editingId ? "✏️ Editar Empleado" : "➕ Nuevo Empleado"}
            </h2>
            {error && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px", color: "#ef4444", fontSize: 13, marginBottom: 14 }}>{error}</div>}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              {[
                { key: "first_name", label: "Nombre *", type: "text" },
                { key: "last_name",  label: "Apellido *", type: "text" },
                { key: "cedula",     label: "Cédula *", type: "text" },
                { key: "hire_date",  label: "Fecha de ingreso *", type: "date" },
              ].map(field => (
                <div key={field.key}>
                  <label style={{ fontSize: 12, fontWeight: 600, color: "#64748b", display: "block", marginBottom: 4 }}>{field.label}</label>
                  <input type={field.type} value={form[field.key]} onChange={e => setForm(p => ({ ...p, [field.key]: e.target.value }))}
                    style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13, boxSizing: "border-box" }} />
                </div>
              ))}

              {/* Salario semanal — auto-calcula mensual */}
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#64748b", display: "block", marginBottom: 4 }}>Salario semanal ($)</label>
                <input type="number" value={form.weekly_salary}
                  onChange={e => {
                    const w = parseFloat(e.target.value) || 0;
                    setForm(p => ({ ...p, weekly_salary: e.target.value, monthly_salary: (w * 4).toFixed(2) }));
                  }}
                  style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13, boxSizing: "border-box" }} />
              </div>

              {/* Salario mensual — solo lectura, calculado automáticamente */}
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#64748b", display: "block", marginBottom: 4 }}>
                  Salario mensual ($) <span style={{ color: "#94a3b8", fontWeight: 400 }}>(semanal × 4)</span>
                </label>
                <input type="number" value={form.monthly_salary} readOnly
                  style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13, boxSizing: "border-box", background: "#f8fafc", color: "#64748b" }} />
              </div>

              {/* Cesta Ticket */}
              <div style={{ gridColumn: "1 / -1" }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#64748b", display: "block", marginBottom: 4 }}>
                  Cesta Ticket ($) <span style={{ color: "#94a3b8", fontWeight: 400 }}>(obligación patronal)</span>
                </label>
                <input type="number" value={form.cesta_ticket}
                  onChange={e => setForm(p => ({ ...p, cesta_ticket: e.target.value }))}
                  style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13, boxSizing: "border-box" }} />
              </div>

              <div style={{ gridColumn: "1 / -1" }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: "#64748b", display: "block", marginBottom: 4 }}>Sede *</label>
                <select value={form.store_id} onChange={e => setForm(p => ({ ...p, store_id: e.target.value }))}
                  style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13 }}>
                  <option value="">Seleccionar sede...</option>
                  {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
              <button onClick={() => { setShowForm(false); setEditingId(null); }}
                style={{ padding: "9px 20px", borderRadius: 8, border: "1px solid #e2e8f0", background: "white", fontSize: 14, cursor: "pointer", color: "#64748b" }}>
                Cancelar
              </button>
              <button onClick={handleSubmit} disabled={saving}
                style={{ padding: "9px 24px", borderRadius: 8, border: "none", background: "#6366f1", color: "white", fontSize: 14, fontWeight: 700, cursor: "pointer", opacity: saving ? 0.6 : 1 }}>
                {saving ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
